import React, {Component} from 'react';
import './tutorials.css';

export default class Tutorials extends Component{
  render(){
    return (
      <section className='main-container'>
        <h1 id='page-title'>Tutorials</h1>
        <ul>
          <li><b><a href='https://www.youtube.com/watch?v=uethAdgTs9k'>Morton Fly</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=s6-TlVgmNHQ'>Vanilla Dome 1 Wings</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=L4sobX4jCuY'>Gnarly Wings</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=tCS5Mmkag0E'>Tubular Wings</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=Y4yU0bFXq_A'>Awesome Reznor Kill (ARK)</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=iMcmUQU7g0A'>Groovy Boss Kill</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=lVmC0d4wFe0'>FOI1 Wings</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=3IDUS4KWIhY'>Roy Fly</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=6-LZdaIPABs'>Sandbar Clip</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=z-YBmnAi9qI'>Cape Kill</a></b> by Bramz.</li>
          <li><b><a href='https://www.youtube.com/watch?v=ubeVWlgnAWs'>Cape Kill</a></b> by Linkdeadx2.</li>
          <li><b><a href='https://www.youtube.com/watch?v=vdWxNuiA-n8'>No Cape Kill</a></b> by MaestroBrau.</li>
          <li><b><a href='https://www.youtube.com/watch?v=ypiHsiRCpEs'>Cloud Fight (Expert Strats)</a></b> by Drams_Cat.</li>
          <li><b><a href='https://www.youtube.com/watch?v=TG_79G7dU9E'>Cloud Fight (Beginner Strats)</a></b> by Drams_Cat.</li>
          <li><b><a href='https://www.youtube.com/watch?v=34zftjJUD3U'>Small Only</a></b> by reze.</li>
        </ul>
      </section>
    )
  }
}